export class DepositosRequest {
    public codigo: number = null;
    public referencia: string =  null;
    public valor: number = null;
    public dataEmissao: Date = null;
    public dataProcessamento: Date = null;
    public dataCancelamento: Date = null;
    public dataInicio: Date = null;
    public dataFim: Date = null;
}

export class GenerateDepositRequest {
    public accountGuid: string;
    public value: number;
    public dueDate: Date;
    public allocatedBalanceId: number;
    public depositType: number;
}

export class SaveDepositRequest {
    public purchaseId: number;
    public personId?: number;
    public personGuid?: string;
    public value: number;
    public dueDate: Date;
    public depositType: number;
    public isNewGeneration: boolean;
}